import React from "react";

import { getRange } from "aible";

import numeral from "numeral";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import {
  BarChart,
  LineChart,
  Line,
  Bar,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Label,
  Cell
} from "recharts";

import styles from "./style.module.css";

class CustomToolTip extends React.Component {
  /*
  componentDidUpdate(prevProps) {
    const { label, payload, updateHoverValue, active } = this.props;

    if(active === false && prevProps.active === true) {
      updateHoverValue(undefined);
    }

    if (label && prevProps.label && label !== prevProps.label) {
      const field =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.field
          : undefined;
      const value =
        payload && payload[0] && payload[0].payload
          ? payload[0].payload.value
          : undefined;

      //this.props.updateHoverValue("ewewew");

      if (field && value) {
        updateHoverValue({
          field: field,
          value: value
        });
      }
    }
  }
  */

  formatNumber(num) {
    const retNum = num;
    if (retNum > 100) {
      return numeral(retNum).format("0,0");
    }
    let sigFigs = 1;
    let currNum = Math.abs(num);
    if (isFinite(currNum) && currNum) {
      while (currNum < 1) {
        currNum *= 10;
        sigFigs += 1;
        if (sigFigs > 10) {
          return retNum;
        }
      }
    }
    let formatString = "0.[0";
    for (let i = 0; retNum < 1 && i < sigFigs; i++) {
      formatString += "0";
    }
    formatString += "]";
    return numeral(retNum).format(formatString);
  }

  render() {
    const { active, payload, outcome, xLabel, spikes } = this.props;
    if (!active || !payload || !payload[0] || !payload[0].payload) {
      return null;
    }

    const currPayload = payload && payload[0] && payload[0].payload;

    const outcomeKeys = Object.keys(currPayload).filter((k) => k !== "val");

    let spikeOutcomeKey = outcomeKeys.length === 1 ? outcomeKeys[0] : outcomeKeys.find((k) => k !== "Outcome");

    const retOutcome = currPayload.Outcome !== undefined ? currPayload.Outcome : currPayload[spikeOutcomeKey];

    return (
      <div className={styles.cTooltip}>
        <div className={styles.tModel}>
          {xLabel + ": " + (payload[0].payload.x_real ? payload[0].payload.x_real : payload[0].payload.val)}
        </div>
        <div className={styles.tBody}>
          <div className={styles.tLabel}>{outcome + ": "}</div>
          <strong>{this.formatNumber(retOutcome)}</strong>
        </div>
      </div>
    );
  }
}

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const RenderLegend = (props) => {
  const { successStrings } = props;

  return (
    <div className={styles.legendHolder}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.positive} />
        <div>{successStrings.positive}</div>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.negative} />
        <div>{successStrings.negative}</div>
      </div>
    </div>
  );
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  const retVal = num.toString().match(re);
  return retVal ? reVal[0] : num;
}

class PartialDepPlot extends React.Component {
  injectSpikes(data, rawSpikes) {
    if (!rawSpikes || !Object.keys(rawSpikes).length) {
      let min = Infinity;
      let max = -Infinity;
      for (let i = 0; i < data.length; i++) {
        const currPoint = data[i];
        min = Math.min(min, currPoint.Outcome);
        max = Math.max(max, currPoint.Outcome);
      }
      return {
        min: min,
        max: max,
        data: data
      };
    }

    const spikes = { ...rawSpikes };

    const spikesValues = {};

    const spikesList = Object.keys(spikes);
    const retData = [];

    let min = Infinity;
    let max = -Infinity;

    for (let i = 0; i < data.length; i++) {
      const currPoint = data[i];
      let injected = false;
      spikesList.forEach((spikeValue) => {
        const currSpikeValue = Number(spikeValue);
        if (spikesValues[currSpikeValue] === undefined && currSpikeValue < currPoint.val) {
          const spikeArray = [
            {
              val: currSpikeValue,
              ["spike_" + currSpikeValue]: currPoint.Outcome
            },
            {
              val: currSpikeValue,
              ["spike_" + currSpikeValue]: spikes[currSpikeValue]
            }
          ];
          min = Math.min(min, spikes[currSpikeValue]);
          max = Math.max(max, spikes[currSpikeValue]);
          spikesValues[currSpikeValue] = spikeArray;
          retData.push(spikeArray[0]);
          retData.push(spikeArray[1]);
        }
      });

      min = Math.min(min, currPoint.Outcome);
      max = Math.max(max, currPoint.Outcome);
      retData.push(currPoint);
    }

    return {
      min: min,
      max: max,
      data: retData
    };
  }

  render() {
    const { model, fieldSelect, updateFieldSelect, outcome, isFullChart, selected } = this.props;

    if (model === undefined || fieldSelect === undefined) {
      return <div className={styles.nMessage}>{"Not available for this model"}</div>;
    }

    const isOrdered =
      model &&
      model.features &&
      model.features.percentages &&
      model.features.percentages[fieldSelect] &&
      model.features.percentages[fieldSelect].ordered === true &&
      model.features.percentages[fieldSelect].index
        ? true
        : false;

    const fData =
      model && model.plots && model.plots.filter((p) => p.variable_name && p.variable_name === fieldSelect).length > 0
        ? model.plots.filter((p) => p.variable_name && p.variable_name === fieldSelect)[0]
        : undefined;

    if (fData === undefined) {
      return <div className={styles.nMessage}>{"Not available for this model"}</div>;
    }

    const spikes = {};
    if (!fData.values) {
      const spikesList = fData.spikes || [];
      spikesList.forEach((s) => (spikes[s[0]] = s[1]));
    }

    const rawData = fData.values
      ? fData.values
          .map((v, i) => ({
            x: fData.levels[i] && fData.levels[i].length > 20 ? fData.levels[i].slice(0, 20) + "..." : fData.levels[i],
            x_real: fData.levels[i],
            Outcome: v
          }))
          .sort((a, b) => {
            if (isOrdered !== true) {
              return a.x - b.x;
            }
          })
      : fData.x.map((x, i) => ({
          val: x,
          Outcome: fData.y[i]
        }));

    const { data, ...yRange } = this.injectSpikes(rawData, spikes);

    const xLabel = fieldSelect;
    const yLabel = outcome;

    const yDataMin = yRange.min;
    const yDataMax = yRange.max;

    const yDomain = getRange(yDataMin, yDataMax, true);

    const xDataMin = Math.min.apply(
      Math,
      data.map((p) => (fData.type === "NUMERIC_MAIN_EFFECT" ? p.x : p.Outcome)).filter((v) => isFinite(v))
    );
    const xDataMax = Math.max.apply(
      Math,
      data.map((p) => (fData.type === "NUMERIC_MAIN_EFFECT" ? p.x : p.Outcome)).filter((v) => isFinite(v))
    );
    const xDelta = xDataMax - xDataMin;
    const xOffset = 0.001;

    const xDomain = fData.type === "NUMERIC_MAIN_EFFECT" ? [xDataMin - xOffset, xDataMax + xOffset] : [];

    let values = {};
    let models = {};
    let isMax = false;

    isMax = Object.keys(values).length > 1;

    let maxChars = fData.type === "NUMERIC_MAIN_EFFECT" ? 4 : xLabel ? xLabel.length - 10 : 0;

    data &&
      data.forEach((p) => {
        const val = p.x;

        if (val && val.toString().length > maxChars) {
          maxChars = val.toString().length;
        }
      });

    return (
      <div className={styles.pDepChart}>
        {fData.type === "NUMERIC_MAIN_EFFECT" ? (
          <div className={styles.pDepChartInner + (isFullChart ? " " + styles.pDepChartFull : "")} id="pdepChart">
            <ResponsiveContainer>
              <LineChart
                margin={{
                  top: 10,
                  right: 20,
                  bottom: isFullChart ? 20 : 40
                }}
                data={data}
                onClick={() => {}}
              >
                <YAxis type="number" dataKey={"Outcome"} domain={yDomain} width={12 * maxChars + 20}></YAxis>
                <XAxis
                  type="number"
                  dataKey={"val"}
                  name={yLabel}
                  unit={""}
                  tickFormatter={(tick) => (isFinite(tick) ? numeral(tick).format("0.[00]") : "")}
                  domain={xDomain}
                >
                  <Label value={xLabel} offset={0} position="bottom" />
                </XAxis>
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip content={<CustomToolTip outcome={outcome} xLabel={xLabel} spikes={spikes} />} />
                <Line dot={false} dataKey={"Outcome"} connectNulls strokeWidth={2}></Line>
                {Object.keys(spikes).map((sValue) => (
                  <Line key={"spike-" + sValue} dot={false} dataKey={"spike_" + sValue} strokeWidth={2}></Line>
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className={styles.pDepChartInner + (isFullChart ? " " + styles.pDepChartFull : "")} id="pdepChart">
            <ResponsiveContainer>
              <BarChart
                margin={{
                  top: 20,
                  right: 20,
                  bottom: isFullChart ? 10 : 40
                }}
                layout="vertical"
                data={data}
                onClick={() => {}}
              >
                <YAxis
                  type="category"
                  dataKey={"x"}
                  tickFormatter={(tick) => tick.toLocaleString()}
                  width={7 * maxChars + 20}
                ></YAxis>
                <XAxis
                  type="number"
                  dataKey={"Outcome"}
                  name={"Outcome"}
                  unit={""}
                  tickFormatter={(tick) => (tick ? tick.toFixed(2) : "")}
                >
                  <Label value={yLabel} offset={0} position="bottom" />
                </XAxis>
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip content={<CustomToolTip outcome={outcome} xLabel={xLabel} />} />
                <Bar dataKey={"Outcome"}>
                  {data.map((p, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={
                        p.x_real === selected
                          ? "#F47C20"
                          : p.Outcome > 0
                            ? "var(--aible-color)"
                            : "rgba(14, 168, 189, 0.15)"
                      }
                      stroke={p.x_real === selected ? "#F47C20" : p.Outcome > 0 ? "var(--aible-color)" : "#0EA8BD"}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    );
  }
}

export default ResponsiveChart(PartialDepPlot);
